// Hooks & Context
import { createContext, useEffect, useReducer } from 'react';

// Reducers 
import TodosReducer from '../reducers/TodosReducer';
import FilterReducer from '../reducers/FilterReducer';

export const TodosContext = createContext();

export default function TodosProvider({ children }) {
    // current filteration
    const [filteration, filterDispatch] = useReducer(FilterReducer, localStorage.getItem("filteration") || "all");

    // current todos
    const intialTodos = JSON.parse(localStorage.getItem("todos")) || [];
    const [todos, dispatch] = useReducer(TodosReducer, intialTodos);

    // everytime "todos" array changes, update local storage (using reducer)
    useEffect(() => {
        localStorage.setItem("todos", JSON.stringify(todos))
    }, [todos]);

    return (
        <TodosContext.Provider value={{ todos, dispatch, filteration, filterDispatch }}>
            {children}
        </TodosContext.Provider>
    )
}
